import { RequestUrl } from '../types';
import { convertToCamelCase, getHttpRequestSettings } from '../utils';
export async function cancelBackorderDemandHandler({
  detail: {
    lineNumber,
    placement
  }
}) {
  const response = await fetch(`${RequestUrl.CancelBackorderDemand}?lineNumber=${lineNumber}`, getHttpRequestSettings({
    placement
  }));
  return convertToCamelCase(await response.json());
}
//# sourceMappingURL=cancelBackorderDemandHandler.js.map